export { default } from "./Head";
